import React, {useState, useEffect, useRef} from 'react';
import './index.css';
import WrappedMap from '../Map';
import {GoogleMapsAPI} from '@smart-form/GoogleMap/g-config';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Api from '@api';
import { connect, disconnect, subscribe, unsubscribe } from '@common/socketUtil';
import Chip from '../components/common/Chip';
import TrackingCard from '../components/common/TrackingCard';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CircularProgress from '@mui/material/CircularProgress';
import {ReactComponent as Logo} from '../../../../assets/icon/404.svg';
import {useTheme} from '@mui/material';
import AppAnimate from '@crema/core/AppAnimate';
import Box from '@mui/material/Box';
import AuthenticatedImage from '@common/AuthenticatedImage';

const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GoogleMapsAPI}`;

const LiveTrackingPublic = () => {
  const {token} = useParams();
  const theme = useTheme();

  const [center, setCenter] = useState({lat: 22, lng: 77});
  const [zoom, setZoom] = useState(4.9);
  const [vehicles, setVehicles] = useState({});
  const [showTracking, setShowTracking] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isValidURL, setIsValidURL] = useState(true);
  const [tripId, setTripId] = useState(null);
  
  const trackingRef = useRef(null);
  const hasInitializedPosition = useRef(false);

  useEffect(() => {
    if(Object.keys(vehicles).length) {
      setIsLoading(false);
    }else{
      setIsLoading(true);
    }
  }, [vehicles]);

  useEffect(()=>{
    axios.get(`${Api.publicLiveTracking.getValidateToken}/${token}`)
    .then((res)=>{
      const response = res?.data
      if(response.success){
        setTripId(response.tripId);
      }else{
        return setIsValidURL(false)
      }
    })
    .catch((err)=>{
      setIsValidURL(false)
      console.error(err)
    })
  },[token])

  useEffect(() => {
    if(!tripId){
      return;
    }
    connect('PUBLIC', tripId);
    subscribe((data) => {
      if(data.type === 'trip-location-update') {
        setVehicles((prevVehicles) => ({
          ...prevVehicles,
              [data.tripId]: data,
            }));
        }
      });
    return () => {
      unsubscribe();
      disconnect();
    };
  }, [tripId]);

  useEffect(() => {
    if(Object.keys(vehicles).length > 0 && tripId && vehicles[tripId]) {
      const vehicle = vehicles[tripId];
      
      if (!hasInitializedPosition.current) {
        setZoom(15);
        hasInitializedPosition.current = true;
      }
      setCenter({ lat: vehicle.latitude, lng: vehicle.longitude });
    }
  }, [vehicles, tripId]);

  const handleTracking = () => {
    setShowTracking((prev) => !prev);
  };
  
  const currentTrip = tripId ? vehicles[tripId] : null;

  return (
    <div className='live-tracking-public-container'>
      {isValidURL && isLoading && 
        <div className='loading-container'>
          <CircularProgress />
        </div>
      }

      <div className='live-tracking-public-header'>
        {isValidURL && !isLoading ? <AuthenticatedImage
          src={currentTrip?.metadata?.companyLogo}
          alt='Corporate Logo'
          className='live-tracking-public-logo'
        /> : <div></div>}
        <img
          src='/assets/images/tm-logo.jpeg'
          alt='eTravelmate Logo'
          className='live-tracking-public-logo'
        />
      </div>

      {
        !isValidURL && 
          <AppAnimate animation='transition.slideUpIn' delay={200}>
            <div className='live-tracking-public-invalid-url'>
              <Box
              sx={{
                mb: {xs: 4, xl: 8},
                width: '100%',
                maxWidth: {xs: 200, sm: 300, xl: 706},
                '& svg': {
                  width: '100%',
                  maxWidth: 400,
                },
              }}
              > 
                <Logo fill={theme.palette.primary.main} />
              </Box>
              <span>Invalid or expired link</span>
            </div>
          </AppAnimate>
      }

      {isValidURL && 
        <>
          <div className='live-tracking-public-map-container'>
            <WrappedMap
              key={hasInitializedPosition.current ? 'loaded' : 'loading'}
              center={center}
              zoom={zoom}
              googleMapURL={mapURL}
              loadingElement={<div style={{height: `100%`}} />}
              containerElement={<div style={{height: `100%`}} />}
              mapElement={<div style={{height: `100%`}} />}
              siteOfficeLocation={{}}
              vehicles={vehicles}
              fitAllVehicles={false}
              onFitDone={() => {}}
              vehiclesOnline={{}}
            />
          </div>
          
          {/* Tracking Toggle Button */}
          {currentTrip &&
            <div className="public-tracking-chip-container">
              <Chip 
                title="Trip Details" 
                icon={<TimeToLeaveIcon sx={{color: 'black'}}/>} 
                onClick={handleTracking} 
                chipRef={trackingRef} 
              />
            </div>
          }

          {/* Tracking Card Panel */}
          {showTracking && currentTrip && (
            <div className="public-tracking-panel">
              <div className="public-panel-header">
                <span className="public-panel-title">Trip Details</span>
                <button className="public-panel-close" onClick={handleTracking} aria-label="Close">×</button>
              </div>
              <div className="public-panel-body">
                <TrackingCard
                  trip={currentTrip}
                  selectedTripId={null}
                  onSelectTrip={() => {}}
                  disableHover={true}
                />
              </div>
            </div>
          )}      
        </>
      }
    </div>
  );
};

export default LiveTrackingPublic;
